import { useGetMeQuery } from 'features/auth/authApi';
import { selectIsAuthenticated } from 'features/auth/authSlice';
import { useAppSelector } from 'app/store';

/**
 * Syncs the authenticated user's data from the backend on mount.
 * This ensures fields like isEmailVerified stay up-to-date
 * even when modified outside the current browser session.
 */
const useAuthSync = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  useGetMeQuery(undefined, {
    skip: !isAuthenticated,
  });
};

export default useAuthSync;
